<script>
import SearchCard from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/SearchCard.vue'
import DataTable from '@/components/base/DataTable'
import TaskDetail from './components/TaskDetail.vue'
import { tabConfigList, searchConfig01, searchConfig02, STATE, tableOption, startColumn01, startColumn02, endColumn01, endColumn02, endColumn03 } from './investigatorRecovery'
import { getSignPage, getBriefConfig, getSignCount, signBatchDel, signBatchExport, signExport } from '@/api/project-task/setting'

export default {
  name: 'InvestigatorRecovery',
  components: { SearchCard, DataTable, TaskDetail },
  props: {
    briefType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      STATE,
      state: STATE.NOT_SUBMIT,
      tabConfig: tabConfigList,
      checkAll: false,
      tableData: [],
      tableDataLoading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      checkVisible: false,
      loading: false,
      getOption: tableOption,
      isEmpty: true,
      form: {},
      detailId: '',
      briefId: '',
      currentTab: '1'
    }
  },
  computed: {
    projectId: ({ $route }) => $route.params.id,
    getSearchConfig() {
      if(this.state == STATE.NOT_SUBMIT) {
        return searchConfig01
      }else {
        return searchConfig02
      }
      // else if(this.state === STATE.NO_TIMPROVE) {
        
      // }else if(this.state === STATE.SUBMIT) {
        
      // }else if(this.state === STATE.FAILURE) {
        
      // }
    },
    getParams() {
      const { currentPage, pageSize } = this.page
      let parmas = {
        current: currentPage,
        size: pageSize,
        projectId: this.projectId,
        briefType: this.briefType,
        state: this.state,
        ...this.form,
      }
      if(this.form?.createTime) {
        parmas = {
          ...parmas,
          createTimeGe: this.form?.createTime[0]??'',
          createTimeLe: this.form?.createTime[1]??'',
        }
        delete parmas.createTime
      }
      if(this.form?.submitTime) {
        parmas = {
          ...parmas,
          submitTimeGe: this.form?.submitTime[0]??'',
          submitTimeLe: this.form?.submitTime[1]??''
        }
        delete parmas.submitTime
      }
      console.log('parmas', parmas)
      return parmas
    },
    disabledBatchDel: {
      get() {
        return !this.selectionList.length && !this.checkAll
      },
      set() {}
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    getCount() {
      getSignCount(this.projectId, this.briefType).then(res => {
        console.log('res', res)
        console.log('this.tabConfig', this.tabConfig)
        this.tabConfig = this.tabConfig.map(item => ({
          ...item,
          num: res.data.data[item.code]
        }))
      }).finally(() => {
      })
    },
    getConfig() {
      this.loading = true
      getBriefConfig(this.projectId, this.briefType).then(res => {
        const data = res.data.data
        this.isEmpty = !data.active
        this.getList()
      }).finally(() => {
        this.loading = false
      })
    },
    toSet() {
      if(this.briefType === 0) {
        this.$router.push({
          path: '/task/' + this.projectId + '/setting/investigator-setting'
        })
      }else {
        this.$router.push({
          path: '/task/' + this.projectId + '/setting/auditor-setting'
        })
      }
    },
    handleHeaders(data) {
      let start = []
      let end = []
      this.getOption.column = [
        {
          label: '操作',
          value: 'opt',
          fixed: 'right',
          fixWidth: '156px'
        }
      ]
      if(this.state == STATE.NOT_SUBMIT) {
        start = startColumn02
        end = endColumn01
        this.getOption.column = [
          ...start,
          ...data.heads.filter(k => !['姓名', '手机号码'].includes(k)).map(item => ({
            label: item,
            value: item
          })),
          ...end,
          ...this.getOption.column
        ]
      }else if(this.state == STATE.NO_TIMPROVE || this.state == STATE.FAILURE) {
        start = [
          ...startColumn01,
          ...startColumn02
        ]
        end = [
          ...endColumn01,
          ...endColumn02
        ]
        this.getOption.column = [
          ...start,
          ...end,
          ...this.getOption.column
        ]
      }else if(this.state == STATE.SUBMIT) {
        start = [
          ...startColumn01,
          ...startColumn02
        ]
        end = [
          ...endColumn01,
          ...endColumn02,
          ...endColumn03
        ]
        this.getOption.column = [
          ...start,
          ...end,
          ...this.getOption.column
        ]
      }
      console.log('this.getOption.column', this.getOption.column)
    },
    getList() {
      this.tableDataLoading = true
      getSignPage(this.getParams)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.error(res.data.msg)
            this.tableDataLoading = false
            return
          }
          this.handleHeaders(res.data.data)
          this.tableData = res.data.data.records.map(item => ({
            ...item,
            ...item.otherInfo
          }))
          this.$nextTick(()=> {
            this.$refs.crud.doLayout()
          })
          this.page.total = res.data.data.total
          this.page.currentPage = res.data.data.current
          this.page.pageSize = res.data.data.size
          this.getCount()
          this.tableDataLoading = false
        })
        .catch(err => {
          this.tableDataLoading = false
          console.log(err)
        })
    },
    changeTab() {
      this.$refs.searchCard.clearData()
      this.onReset()
    },
    toSearch(value) {
      console.log('value', value)
      this.form = value
      this.getList()
    },
    onReset() {
      this.form = {}
      this.getList()
    },
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    onDel(ids) {
      const data = {
        query: this.getParams
      }
      if(ids) {
        data.selectedIds = ids
      }else if(!ids && this.checkAll){
        data = { query: this.getParams }
      }else if(!ids && !this.checkAll){
        data.selectedIds = this.selectionList.map(item => item.id)
      }
      signBatchDel(data).then(res => {
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getList()
      })
      .catch(err => {
        console.log(err)
      })
    },
    signDownload(id) {
      signExport(id).then(res => {
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          return
        }
        window.open(res.data.data)
        this.$message({
          type: 'success',
          message: '下载成功!'
        })
      })
      .catch(err => {
        console.log(err)
      })
    },
    download(ids) {
      const data = {
        query: this.getParams
      }
      if(ids) {
        data.selectedIds = ids
      }else if(!ids && this.checkAll){
        data = { query: this.getParams }
      }else if(!ids && !this.checkAll){
        data.selectedIds = this.selectionList.map(item => item.id)
      }
      signBatchExport(data).then(res => {
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          return
        }
        window.open(res.data.data)
        this.$message({
          type: 'success',
          message: '下载成功!'
        })
        this.$refs.crud.clearSelection()
      })
      .catch(err => {
        console.log(err)
      })
    },
    batchDel() {
      if (!this.selectionList.length) {
        this.$message.warning('请选择数据')
        return
      }
      this.onDel()
    },
    batchDownload() {
      if (!this.selectionList.length) {
        this.$message.warning('请选择数据')
        return
      }
      this.download()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectAll() {
      if(this.checkAll) {

      }
    },
    onCheck(row) {
      this.checkVisible = true
      if(this.state == STATE.NO_TIMPROVE || this.state == STATE.FAILURE) {
        this.currentTab = '2'
      }else {
        this.currentTab = '1'
      }
      this.detailId = row.id
      this.briefId = row.briefId
    }
  }
}
</script>

<template>
  <div v-loading="loading" class="p-4 h-full box-border">
    <div v-if="isEmpty" class="bg-white box-border rounded-small" style="padding: 67px 0;">
      <p class=" font-semibold text-theme-black-850 text-20 leading-22 text-center mb-3">
        {{ briefType === 0 ? '调查员任务书' : '审核员任务书' }}
      </p>
      <p class="text-theme-black-650 leading-22 text-center mb-6">开启项目任务书，设置任务书内容后查看签署进度</p>
      <el-button type="primary" style="width: 88px" class="block mx-auto my-0 mb-8" @click="toSet">前往设置</el-button>
      <div style="width: 894px; height: 509px;background: #F7F9FB;" class="rounded-small mx-auto my-0">
        <img src="~@/assets/img/project-task/progress.png" width="100%">
      </div>
    </div>
    <!-- tab选项卡、查询、表格 -->
    <div v-else
      class="main p-4 box-border bg-white h-full rounded-small"
    >
      <el-tabs
        v-model="state"
        @tab-click="changeTab"
      >
        <el-tab-pane
          v-for="(item, index) in tabConfig"
          :key="index"
          :label="item.label + ' ' + item.num"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>
      <SearchCard ref="searchCard" class="mt-2" :searchConfig="getSearchConfig" @to-search="toSearch" @on-reset="onReset" />
      <data-table
        style=" height: calc(100% - 114px)"
        ref="crud"
        align="left"
        height="calc(100% - 48px)"
        :columns="getOption.column"
        :isShowCheckAll="getOption.isShowCheckAll"
        :isShowCheckCount="getOption.isShowCheckCount"
        :checkAll.sync="checkAll"
        :data="tableData"
        :loading="tableDataLoading"
        :selection="state == STATE.NOT_SUBMIT || state == STATE.SUBMIT ||  STATE.NO_TIMPROVE"
        showPage
        :page="page"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
        @selection-change="selectionChange"
        @select-all="selectAll"
      >
        <template #opt="{ row }">
          <el-button
            class="mr-3"
            type="text"
            v-if="state == STATE.NO_TIMPROVE || state == STATE.FAILURE"
            @click="onCheck(row)"
          >
            查看
          </el-button>
          <el-button
            class="mr-3"
            type="text"
            v-if="state == STATE.SUBMIT || STATE.NO_TIMPROVE"
            @click="signDownload(row.id)"
          >
            下载
          </el-button>
          <el-popconfirm title="确定删除吗？" @confirm="onDel([row.id])" cancel-button-type="">
            <el-button class="mr-3" slot="reference" type="text" v-if="state == STATE.NOT_SUBMIT">
              删除
            </el-button>
          </el-popconfirm>
        </template>
        <template slot="page-left">
          <el-button
            :disabled="!selectionList.length"
            class="ml-3"
            type="primary"
            v-if="state == STATE.SUBMIT || STATE.NO_TIMPROVE"
            @click="batchDownload"
          >
            批量下载
          </el-button>
          <el-popconfirm title="确定删除吗？" :disabled="!selectionList.length" @confirm="batchDel">
            <el-button
              class="ml-3"
              slot="reference"
              type="primary"
              plain
              v-if="state == STATE.NOT_SUBMIT"
              :disabled="disabledBatchDel">
              批量删除
            </el-button>
          </el-popconfirm>
        </template>
      </data-table>
    </div>
    <TaskDetail :visible.sync="checkVisible" :id="detailId" :briefId="briefId" :tab.sync="currentTab"/>
  </div>
</template>

<style scoped lang="scss">

</style>
